module.exports = __webpack_public_path__ + "img/tick-prefs.dd543793.png";